
/** Trạng thái "mất tín hiệu liên lạc" — cách viết ĐÚNG, dùng ở mọi nơi trong mã. */
export const LOST_GSM = 'lost_gsm';

/**
 * Cách viết CŨ, sai chính tả, vẫn đang chạy trên dây.
 *
 * ĐỪNG XOÁ. Server phát chuỗi này cho tới nhịp migrate, và app Flutter bản cũ nằm trên điện thoại
 * người dùng gửi lên chuỗi này VĨNH VIỄN — không có cách nào ép những máy đó cập nhật. Người vận
 * hành đã chốt ngày 12/09/2026 là giữ bí danh không thời hạn. Xoá nó đi thì bộ lọc "mất kết nối"
 * trên app cũ trả về rỗng, và lỗi chỉ lộ ra trên máy khách chứ không ở đây.
 */
export const LOST_GSM_LEGACY = 'lost_gms';

const SUPPORTED_STATUSES = ['lost_gps', LOST_GSM, 'stopped', 'moving', 'over_speed'];

export const getNormalizedVehicleStatus = status => {
    const normalizedStatus = String(status || '').toLowerCase();

    // Bí danh quy về cách viết đúng trước khi làm bất cứ việc gì khác.
    if (normalizedStatus === LOST_GSM_LEGACY) return LOST_GSM;

    // Trạng thái lạ rơi về "mất liên lạc": không biết xe thế nào thì chỉ nói được là mất liên lạc.
    // Giữ nguyên tính chất này — nó là tấm lưới khi server và giao diện lệch phiên bản.
    return SUPPORTED_STATUSES.includes(normalizedStatus) ? normalizedStatus : LOST_GSM;
};

/**
 * So hai trạng thái sau khi chuẩn hoá cả hai phía.
 *
 * Dùng ở mọi chỗ đối chiếu bộ lọc với trạng thái của xe: một bên là giá trị trong `CAR_STATUS`
 * (đã viết đúng), bên kia là chuỗi server gửi về (có thể còn viết cũ). So thẳng bằng `===` là
 * cách chắc chắn nhất để làm cả một nhóm xe biến mất khỏi bản đồ.
 *
 * RỖNG KHÔNG PHẢI LÀ MỘT TRẠNG THÁI. `getNormalizedVehicleStatus` cố tình cho chuỗi lạ rơi về
 * `lost_gsm` — hợp lý khi vẽ icon cho một chiếc xe, nhưng sai khi so sánh: "chưa chọn bộ lọc"
 * (`''`/`null`) khi đó bằng đúng bộ lọc "mất 4G", nên ô đó sáng sẵn lúc mới vào màn hình và bấm
 * vào nó lại hoá ra bấm lần thứ hai — bộ lọc không bao giờ bật được. Chặn ở đây chứ không ở từng
 * nơi gọi: mười bốn chỗ đang so sánh, bỏ sót một chỗ là lỗi quay lại.
 */
export const isSameVehicleStatus = (a, b) => {
    const isBlank = value => value === null || value === undefined || String(value).trim() === '';
    if (isBlank(a) || isBlank(b)) return false;

    return getNormalizedVehicleStatus(a) === getNormalizedVehicleStatus(b);
};

export const getIconStatus = (status, type) => {
    const normalizedStatus = getNormalizedVehicleStatus(status);
    const defaultIcon = `/static/iconSvg/cars/car_lost_gsm.svg`
    const iconMapping = {
        'Xe ô tô con': {
            lost_gps: '/static/iconSvg/cars/car_lost_gps.svg',
            lost_gsm: '/static/iconSvg/cars/car_lost_gsm.svg',
            stopped: '/static/iconSvg/cars/car_stopped.svg',
            moving: '/static/iconSvg/cars/car_moving.svg',
            over_speed: '/static/iconSvg/cars/car_out_speed.svg',
        },
        'Xe khách': {
            lost_gps: '/static/iconSvg/coach/coach_lost_gps.svg',
            lost_gsm: '/static/iconSvg/coach/coach_lost_gsm.svg',
            stopped: '/static/iconSvg/coach/coach_stopped.svg',
            moving: '/static/iconSvg/coach/coach_moving.svg',
            over_speed: '/static/iconSvg/coach/coach_out_speed.svg',
        },
        'Xe tải': {
            lost_gps: '/static/iconSvg/trucks/truck_lost_gps.svg',
            lost_gsm: '/static/iconSvg/trucks/truck_lost_gsm.svg',
            stopped: '/static/iconSvg/trucks/truck_stopped.svg',
            moving: '/static/iconSvg/trucks/truck_moving.svg',
            over_speed: '/static/iconSvg/trucks/truck_out_speed.svg',
        },
        'Xe bồn': {
            lost_gps: '/static/iconSvg/tankTrucks/tankTruck_lost_gps.svg',
            lost_gsm: '/static/iconSvg/tankTrucks/tankTruck_lost_gsm.svg',
            stopped: '/static/iconSvg/tankTrucks/tankTruck_stopped.svg',
            moving: '/static/iconSvg/tankTrucks/tankTruck_moving.svg',
            over_speed: '/static/iconSvg/tankTrucks/tankTruck_out_speed.svg',
        },
        'Thuyền': {
            lost_gps: '/static/iconSvg/boats/boat_lost_gps.svg',
            lost_gsm: '/static/iconSvg/boats/boat_lost_gsm.svg',
            stopped: '/static/iconSvg/boats/boat_stopped.svg',
            moving: '/static/iconSvg/boats/boat_moving.svg',
            over_speed: '/static/iconSvg/boats/boat_out_speed.svg',
        },
        'Tàu hỏa': {
            lost_gps: '/static/iconSvg/trains/train_lost_gps.svg',
            lost_gsm: '/static/iconSvg/trains/train_lost_gsm.svg',
            stopped: '/static/iconSvg/trains/train_stopped.svg',
            moving: '/static/iconSvg/trains/train_moving.svg',
            over_speed: '/static/iconSvg/trains/train_out_speed.svg',
        },
        'Xe Container': {
            lost_gps: '/static/iconSvg/container/container_lost_gps.svg',
            lost_gsm: '/static/iconSvg/container/container_lost_gsm.svg',
            stopped: '/static/iconSvg/container/container_stopped.svg',
            moving: '/static/iconSvg/container/container_moving.svg',
            over_speed: '/static/iconSvg/container/container_out_speed.svg',
        },
        'Xe máy': {
            lost_gps: '/static/iconSvg/motors/motor_lost_gps.svg',
            lost_gsm: '/static/iconSvg/motors/motor_lost_gsm.svg',
            stopped: '/static/iconSvg/motors/motor_stopped.svg',
            moving: '/static/iconSvg/motors/motor_moving.svg',
            over_speed: '/static/iconSvg/motors/motor_out_speed.svg',
        },
        'Con người': {
            lost_gps: '/static/iconSvg/human/human_lost_gps.svg',
            lost_gsm: '/static/iconSvg/human/human_lost_gsm.svg',
            stopped: '/static/iconSvg/human/human_stopped.svg',
            moving: '/static/iconSvg/human/human_moving.svg',
            over_speed: '/static/iconSvg/human/human_out_speed.svg',
        }
        
    };
    const defaultTypeMapping = {
        lost_gps: '/static/iconSvg/cars/car_lost_gps.svg',
        lost_gsm: '/static/iconSvg/cars/car_lost_gsm.svg',
        stopped: '/static/iconSvg/cars/car_stopped.svg',
        moving: '/static/iconSvg/cars/car_moving.svg',
        over_speed: '/static/iconSvg/cars/car_out_speed.svg',
    };
    return iconMapping[type]?.[normalizedStatus] || defaultTypeMapping[normalizedStatus] || defaultIcon;
};

export const vehicleStates = [
    {
      list: 'lost_gsm_vehicles',
      id: 1
    },
    {
      list: 'over_speed_vehicles',
      id: 2
    },
    {
      list: 'stop_vehicles',
      id: 3
    },
    {
      list: 'running_vehicles',
      id: 4
    },
    {
      list: 'lost_gps_vehicles',
      id: 5
    }
  ];
